export default __webpack_public_path__ + "static/cta-img-1-b62c9cc6e9dc332a0bafdcac5ee1a172.jpg";